import { useMemo } from "react";
import { Typography } from "@mui/material";
import { Skeleton } from "@mui/material";
import PropTypes from "prop-types";
import { Autocomplete } from "components/Autocomplete";
import { useMachinesQuery } from "hooks/queries/useMachinesQuery";

export function MachineDropdown({ value, siteId, onChange, ...rest }) {
  const { isLoading, isError, data: machines } = useMachinesQuery();

  const siteMachines = useMemo(
    () =>
      siteId
        ? machines?.results?.filter(({ site }) => site === siteId) ?? []
        : machines?.results,
    [siteId, machines]
  );

  if (isLoading) {
    return <Skeleton variant="rectangular" width="100%" height={56} />;
  }

  if (isError) {
    return <Typography>An error occurred</Typography>;
  }

  return (
    <Autocomplete
      value={value}
      loading={isLoading}
      error={isError}
      onChange={onChange}
      label="Machine"
      options={siteMachines}
      variant="outlined"
      getOptionLabel={option => option.name}
      fullWidth
      {...rest}
    />
  );
}

MachineDropdown.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func,
  siteId: PropTypes.number
};
